import {
  LISTADO_ESPECIES_BIEN_REQUEST,
  LISTADO_ESPECIES_BIEN_SUCCESS,
  COMBO_ESPECIES_BIEN_SUCCESS,
  LISTADO_ESPECIES_BIEN_FAIL,
} from "../types";
import { Dispatch } from "redux";
import axiosInstance from "../../../../services/axiosConfig";

export const listadoDeEspeciesBienActions = (EST: number, IDBIEN: number, esP_CODIGO: string, esP_NOMBRE: string) => async (dispatch: Dispatch, getState: any): Promise<boolean> => {

  dispatch({ type: LISTADO_ESPECIES_BIEN_REQUEST });

  try {
    const res = await axiosInstance.get(`${import.meta.env.VITE_CSRF_API_URL}/comboListadoDeEspeciesBienPar?EST=${EST}&IDBIEN=${IDBIEN}&esP_CODIGO=${esP_CODIGO}&esP_NOMBRE=${esP_NOMBRE}`);
    const { comboEspecies } = getState().listadoDeEspeciesBienReducers;
    if (res.status === 200) {
      if (res.data?.length) {
        dispatch({
          type: LISTADO_ESPECIES_BIEN_SUCCESS,
          payload: res.data,
        });

        if (!comboEspecies || comboEspecies.length !== res.data.length) {
          dispatch({
            type: COMBO_ESPECIES_BIEN_SUCCESS,
            payload: res.data,
          });
        }
        return true;
      }
      else {
        dispatch({ type: LISTADO_ESPECIES_BIEN_FAIL });
        return false;
      }
    } else {
      dispatch({
        type: LISTADO_ESPECIES_BIEN_FAIL,
        error:
          "No se pudo obtener el listado de especies. Por favor, intente nuevamente.",
      });
      return false;
    }
  } catch (err) {
    // console.error("Error en la solicitud:", err);
    dispatch({ type: LISTADO_ESPECIES_BIEN_FAIL });
    return false;
  }
};
